import { render } from "./PromotionList.vue?vue&type=template&id=0ad006b2&scoped=true&ts=true"
import script from "./PromotionList.vue?vue&type=script&lang=ts"
export * from "./PromotionList.vue?vue&type=script&lang=ts"

import "./PromotionList.vue?vue&type=style&index=0&id=0ad006b2&scoped=true&lang=css"
import "./PromotionList.vue?vue&type=style&index=1&id=0ad006b2&lang=css"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad006b2"]])

export default __exports__